module.exports = function (Restangular) {
    function BazaarvoiceService() {
        this._ratingsandReviewsApi = Restangular.one('BazaarVoice/RatingsAndReviews');
        this._submitReviewApi = Restangular.one('BazaarVoice/WriteReview');
        this._submitFeedbackApi = Restangular.one('/BazaarVoice/FeedbackSubmission');
    }

    BazaarvoiceService.prototype.get = function (ProductId, ShopperId, Sort, PageSize, PageOffset) {
        return this._ratingsandReviewsApi.get({ ProductId, ShopperId, Sort, PageSize, PageOffset });
    };

    BazaarvoiceService.prototype.postReview = function (body) {
        return this._submitReviewApi.post('', body);
    };

    BazaarvoiceService.prototype.postFeedback = function (body) {
        return this._submitFeedbackApi.post('', body);
    };
    return new BazaarvoiceService();
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/bazaarvoiceservice/bazaarvoice-service.js
 **/